import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.img`
  ${({ displayState }) => css`
    max-width: 100%;
  `}
`;

export default Atom({ type: 'image', dataType: 'string', template })